import JwtService from "@/auth/jwt/jwtService";
import axios from "@/libs/axios"; // the default, latest version
import axiosInsights from "@/libs/axiosInsights";
import axiosV1 from "@/libs/axiosV1";
import axiosV2 from "@/libs/axiosV2";

const apiV1 = new JwtService(axiosV1);
const apiV2 = new JwtService(axiosV2);
const apiLatest = new JwtService(axios);
const insightsApi = new JwtService(axiosInsights);

export default apiV2;

export const api: { V1: JwtService; V2: JwtService; V3: JwtService; insights: JwtService } = {
    V1: apiV1,
    V2: apiV2,
    V3: apiLatest,
    insights: insightsApi,
};

export function useJwt() {
    // do nothing, as JWT services are already loaded on import
}
